export default __webpack_public_path__ + "assets/en-GB.cc90f8c0bf8805150e434307d434c80f.svg";